import { createApiRef } from "@backstage/core-plugin-api";

import type {
  AssignmentLookupRequest,
  AssignmentLookupResponse,
  AssignmentsListResponse,
  CachedCloudExplorerResponse,
  CloudProvider,
  EntityAssetsResponse,
  EntityAssignmentCostsResponse,
  ExplorerAccountAssetsResponse,
  ExplorerAccountsResponse,
  ExplorerAssetApiDetail,
} from "./types";

export const explorerApiRef = createApiRef<ExplorerApi>({
  id: "plugin.cloudhealth-explorer.service",
});

export interface ExplorerApi {
  getCloud(cloud: CloudProvider): Promise<CachedCloudExplorerResponse>;
  getAccounts(cloud: CloudProvider): Promise<ExplorerAccountsResponse>;
  getAccountAssets(
    cloud: CloudProvider,
    accountId: string,
    displayName: string,
  ): Promise<ExplorerAccountAssetsResponse>;

  // ─── Phase 2: Account-level assignments ───────────────────────────────

  /** List assignments, optionally filtered by nodeRef or entityRef. */
  getAssignments(options?: {
    nodeRef?: string;
    entityRef?: string;
    limit?: number;
  }): Promise<AssignmentsListResponse>;

  /** Delete an assignment by id. */
  deleteAssignment(id: string): Promise<void>;

  /** Get account-level assigned assets for a given entity. */
  getEntityAssets(entityRef: string): Promise<EntityAssetsResponse>;

  /** Lookup assignments for specific nodeRefs with optional inherited resolution. */
  lookupAssignments(
    request: AssignmentLookupRequest,
  ): Promise<AssignmentLookupResponse>;

  // ─── Phase 5: FinOps costs by assignment ───────────────────────────────

  /** Get cost summaries for all accounts assigned to a given entity. */
  getEntityCosts(entityRef: string): Promise<EntityAssignmentCostsResponse>;

  /** Fetches CloudHealth API attributes and relations for a single asset. */
  getAssetDetails(nodeRef: string): Promise<ExplorerAssetApiDetail>;
}
